export default __webpack_public_path__ + "static/NuvemFiscalNFe-f04f7ddb16910675d34698d13965758f.png";